import { nanoid } from '@reduxjs/toolkit';
import avatar1 from '../../assets/images/placeholders/avatar-1.jpg';
import avatar2 from '../../assets/images/placeholders/avatar-2.jpg';
import { translate } from '@state/utils/helper';

export interface IChat {
  id: string;
  name: string;
  lastMessage: string;
  messageStatus: string;
  lastMessageTime: string;
  profilePicture: string;
  online: boolean;
  itemType?: string;
}
export const Chats: IChat[] = [
  {
    id: nanoid(),
    name: translate('chat.profile1Name'),
    lastMessage: translate('chat.chatMessage1'),
    messageStatus: 'locked',
    lastMessageTime: '3:01 PM',
    profilePicture: avatar1,
    online: false,
  },
  {
    id: nanoid(),
    name: translate('chat.profile2Name'),
    lastMessage: translate('chat.chatMessage2'),
    messageStatus: 'locked',
    lastMessageTime: '3:02 PM',
    profilePicture: avatar2,
    online: false,
  },
];
